import React, { useEffect, useRef, useState } from "react";
import Router from 'next/router'
import { Form, Input, Button, Row, Col, Carousel, Alert, Divider, message } from "antd";
import Layout from "antd/lib/layout/layout";
import { toastM } from "../components/Toast";
import { getEventDetails, getExhibitorLoginScreen, login, loginDelegate, loginDelegateOtp, sendOtp } from "../api/auth/login";
import Error from 'next/error';
import { asImmutable, getCookieClientConfig, getCookies, getEventLogo, getSubdomainFromCookie, getSubdomainFromHost, getSubdomainFromReq, makeError, mediaSizes, setCookies } from "../../helpers/utils";
import moment from "moment";
import Head from "next/head";
import Link from "next/link";
import { ArrowDownOutlined } from "@ant-design/icons";
import { getConfig } from "../../config/getConfig";


const Login = ({ error, errorCode, errorTitle, ...props }) => {

    const ref = useRef();
    const loginPanelRef = useRef();
    const arrowRef = useRef();

    const templateType = props.template_type || 30; //default = 30, 10 = original, 20 = compact, 30 = compact 2

    // const _params = useSearchParams()
    // const params = {}
    // for (let entry of _params.entries()) {
    //     params[entry[0]] = entry[1]
    // }

    const [loginType, setLoginType] = useState(10) //10 delegate, 20 exhibitor
    const [otpKey, setOtpKey] = useState()
    const [isLg, setisLg] = useState()


    const [adsCount, setAdsCount] = useState(2)
    const [text] = useState(props.note)
    // const [text] = useState('<table class="component-api-table"><thead><tr><th>Property</th><th>Description</th><th>Type</th><th>Default</th><th>Version</th></tr></thead><tbody><tr><td>className</td><td>The className of Icon</td><td>string</td><td>-</td><td></td></tr><tr><td>rotate</td><td>Rotate by n degrees (not working in IE9)</td><td>number</td><td>-</td><td></td></tr><tr><td>spin</td><td>Rotate icon with animation</td><td>boolean</td><td>false</td><td></td></tr><tr><td>style</td><td>The style properties of icon, like <code>fontSize</code> and <code>color</code></td><td>CSSProperties</td><td>-</td><td></td></tr><tr><td>twoToneColor</td><td>Only supports the two-tone icon. Specify the primary color</td><td>string (hex color)</td><td>-</td><td></td></tr></tbody></table>')
    const [hasCarousel, setHasCarousel] = useState(text ? false : props.carousel && props.carousel.length > 0)
    // const [hasCarousel, setHasCarousel] = useState(false)
    // const [carousel, setCarousel] = useState(props.carousel)

    useEffect(() => {
        async function getLoginType() {
            try {
                const type = getCookieClientConfig()?.api_login_type;
                if (type) {
                    setLoginType(type)
                }
            } catch (e) {
                console.error(e);
            }
        }
        getLoginType();
    }, [])

    const handleScroll = () => {
        const container = loginPanelRef.current;
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        const scrollHeight = container.scrollHeight;

        if (scrollTop + clientHeight >= scrollHeight - 1) {
            arrowRef.current.classList.add('__hide');
        } else {
            arrowRef.current.classList.remove('__hide');
        }
    };

    const loginFormScrollable = () => {
        const container = loginPanelRef.current;
        const arrow = arrowRef.current;

        if (container && arrow) {
            const isVerticallyScrollable = container.scrollHeight > container.clientHeight;

            if (isVerticallyScrollable) {
                arrowRef.current.classList.remove('__hide');
                container.addEventListener('scroll', handleScroll);
            } else {
                arrowRef.current.classList.add('__hide');
            }
        }
    };

    const scrollToBtm = () => {
        const container = loginPanelRef.current;
        container.scrollTo({
            top: container.scrollHeight - container.clientHeight,
            behavior: 'smooth'
        });
    }



    const handleResize = () => {
        if (props?.carousel?.length == 1) {
            setAdsCount(1)
        } else {
            if (ref.current && ref.current.clientWidth > 900) {
                setAdsCount(3)
            } else if (ref.current && ref.current.clientWidth > 600) {
                setAdsCount(2)
            } else {
                setAdsCount(1)
            }
        }
        if (typeof window !== "undefined") {
            setisLg(window.matchMedia(`(min-width: ${mediaSizes['lg']})`).matches)
        }
        loginFormScrollable()
    }



    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize()
        return () => window.removeEventListener('resize', handleResize);
    }, [ref])

    useEffect(() => {
        Object.keys(localStorage).filter(x => x.startsWith('menu')).map(x => {
            localStorage.removeItem(x)
        })
    }, [])


    if (errorCode || errorTitle) {
        return <div className='bg-stone-500'><Error message={error} statusCode={errorCode} title={errorTitle} /></div>
    }


    const __title = 'Login'


    const onFinish = async (values) => {
        if (loginType == 20) {
            const formData = new FormData();

            Object.keys(values).forEach((element) => {
                formData.append(element, values[element]);
            });

            await fetch('/api/auth/' + props.id + '/login_otp', {
                body: JSON.stringify(values),
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(async (response) => {
                    if (response.ok) {
                        Router.push('/')
                    } else {
                        const res = await response.json()
                        toastM.error(asImmutable(res || {}).getIn(['message']) || e.message || 'Error Try again!')
                    }
                })
        } else {
            if (otpKey) {

                await fetch('/api/auth/' + props.id + '/login_verify', {
                    body: JSON.stringify({
                        'username': values['email'],
                        'key': otpKey,
                        'otp': values['otp'],
                        'device_type': 30,
                    }),
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(async (response) => {
                        if (response.ok) {
                            const maxAge = Math.round((new Date(Date.now() + 86400 * 1000) - Date.now()) / 1000);
                            setCookies("event_start_date", props.event_start_date, maxAge);
                            setCookies("event_end_date", props.event_end_date, maxAge);
                            Router.push('/')
                        } else {
                            const res = await response.json()
                            toastM.error(res?.message || 'Error')
                        }
                    })

            } else {
                const data = await loginDelegate(props.id, values['email'],)
                    .then((response) => {
                        return response
                    }).catch(e => {
                        toastM.error(e?.response?.data?.message || 'Error')
                        return null
                    })

                if (data) {
                    if (data?.data?.key) {
                        setOtpKey(data?.data?.key)
                        toastM.success("OTP send successfully")
                        await sendOtp(props.id, data?.data?.key, 0,).then(e => e).catch(e => console.log(e))
                    }
                }
            }

            // const response = await fetch('/api/auth/' + props.id + '/login_otp', {
            //     body: JSON.stringify(values),
            //     method: "POST",
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            // })
            //    
        }
    };








    return <>
        <Head>
            <title>{__title}</title>
        </Head>
        <Layout
            className="p-0 min-h-screen h-full __login_form_panel" ref={loginPanelRef}
            style={{
                backgroundSize: "cover",
                '--bg': '#242F39',
                '--bgcontent': 'white',
                background: 'var(--bg)'
            }}
        >

            <div className="m-0 p-0 h-full w-full flex flex-col lg:flex-row gap-2">
                <div ref={ref}
                    // md={12}
                    // lg={text ? 12 : 14}
                    // span={24}
                    className="__login_banner rounded-br-[24px] lg:rounded-br-[32px] sm:h-auto xs:h-auto lg:min-h-screen flex flex-col gap-2 order-2 lg:order-1"

                >

                    <div className="text-center w-full __banner_img "
                    // style={hasCarousel ? { height: isLg ? 'calc(100vh - 220px)' : 'auto' } : {}}
                    // style={hasCarousel ? { maxHeight: isLg ? 'calc(100vh - 220px)' : 'fit-content' } : {}}
                    >
                        {props.exhibitor_banners ? <a href={props.exhibitor_banners.banner_url || '#'}
                            key={props.exhibitor_banners.exhibitor_banner_id}
                        >
                            <img alt=""
                                className="m-auto object-contain"
                                src={`${props.exhibitor_banners.banner_image}`}
                            />
                        </a> : null}
                    </div>


                    {
                        text ? <>
                            <div style={{ height: '0.5rem' }} className="w-full __divider"></div>
                            <div className="w-full m-auto"
                                dangerouslySetInnerHTML={{ __html: text }}
                            />
                        </>
                            : hasCarousel && adsCount > 0 ?
                                <>
                                    <div style={{ height: '0.5rem' }} className="w-full __divider"></div>
                                    <div className="overflow-hidden flex flex-wrap justify-around items-center w-full __login_bottom_carousel"
                                        style={{ height: 'auto', padding: 10 }}>
                                        {adsCount > 1 ?
                                            [...Array(adsCount)].map((x, index) => {
                                                return <CarouselItem key={index + '_' + adsCount} {...{ index, adsCount, carousel: props.carousel }} />
                                            }) :
                                            <a href={props.carousel[0].banner_url || '#'} key={props.carousel[0].exhibitor_banner_id} className="w-full0">
                                                <img
                                                    className="rounded shadow-7xl flex-10 bg-white w-full"
                                                    alt=""
                                                    src={`${props.carousel[0].banner_image}`} />
                                            </a>
                                        }

                                    </div>
                                </> : null}


                    {/* </div> */}
                </div>
                <div
                    // md={12}
                    // lg={text ? 12 : 10}
                    // span={24}
                    className="pl-0 flex flex-col item-start order-1 lg:order-2"
                // style={{ minWidth: isLg ? '40vw' : '100%' }}
                >
                    <div className='w-full flex items-center md:items-inherit h-full' >
                        {/* px-24 md:px-12 sm:px-3 */}
                        <div
                            className="flex flex-col items-center bg-white rounded-tl-[24px] lg:rounded-tl-[0px] lg:rounded-bl-[32px] shadow justify-center lg:h-full w-full  p-5"
                        >
                            <div className="flex flex-col border p-3 lg:p-5 items-center">
                                <div className={`w-full pl-3 md:pl-8 mt-8 lg:mt-0 text-center flex items-center ${templateType == 30 ? 'flex-row justify-center' : 'flex-col'}`}>
                                    <div className="flex flex-col">
                                        <div className={`font-bold ${props.event_logo ? 'text-xl' : 'text-5xl'} ${templateType == 10 ? 'mt-4 mb-3' : (templateType == 20 || templateType == 30 ? 'my-1' : '')}`}>{props.event_name}</div>
                                        <div className={`font-bold text-lg ${templateType == 10 ? 'mb-5' : (templateType == 20 || templateType == 30 ? 'mb-1' : '')}`} >{
                                            `${moment(props.event_start_date).format('MMM DD')}
                                        - ${moment(props.event_end_date).format('MMM DD, YYYY')}
                                        `}
                                        </div>
                                    </div>
                                    {
                                        templateType == 30 && <Divider className="h-[75%] min-h-[100px]" type="vertical" />
                                    }
                                    {props.event_logo ? <img
                                        alt=""
                                        src={`${props.event_logo}`}
                                        className={`${templateType == 10 ? 'my-5 pb-3' : (templateType == 20 || templateType == 30 ? 'my-2' : '')}`}
                                        style={{ maxWidth: 300, maxHeight: templateType == 10 ? 250 : (templateType == 20 || templateType == 30 ? 180 : '') }}
                                    /> : <></>}
                                </div>


                                <div className="flex flex-col w-full px-4 items-center lg:px-2 xl:px-12 mt-1"
                                    style={{ maxWidth: 600 }}>
                                    <Form
                                        name="basic"
                                        layout={templateType == 30 ? "horizontal" : "vertical"}
                                        onFinish={onFinish}
                                        className="w-full px-5 mx-2 lg:mx-8 "

                                    >
                                        {loginType == 20 ? <>
                                            <Form.Item
                                                label="Email / Phone"
                                                name="email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please Enter your Email/Phone!",
                                                    },
                                                ]}
                                                className={`${templateType == 10 ? 'mb-5' : (templateType == 20 || templateType == 30 ? 'mb-2' : '')}`}
                                                labelCol={{ span: 6, lg: templateType == 30 ? 8 : 24, xxl: templateType == 30 ? 6 : 24 }}
                                                wrapperCol={{ span: 18, lg: templateType == 30 ? 16 : 24, xxl: templateType == 30 ? 18 : 24 }}
                                            >
                                                <Input />
                                            </Form.Item>

                                            <Form.Item
                                                label="Password"
                                                name="password"
                                                rules={[
                                                    { required: true, message: "Please Enter Your Password!" },
                                                ]}
                                                labelCol={{ span: 6, lg: templateType == 30 ? 8 : 24, xxl: templateType == 30 ? 6 : 24 }}
                                                wrapperCol={{ span: 18, lg: templateType == 30 ? 16 : 24, xxl: templateType == 30 ? 18 : 24 }}
                                            >
                                                <Input.Password />
                                            </Form.Item>

                                            <div className="my-2 flex flex-row justify-between gap-3 w-100">
                                                <div className="flex items-center">
                                                    <Link href={`/${props?.event_id}/reset-password`} className="__primary_color font-semibold">
                                                        Forgot Password ?
                                                    </Link>
                                                </div>
                                                <Button type="primary" htmlType="submit" className="mt-2 __btn px-4 __bt_primary border-0" style={{
                                                    backgroundColor: '#E72D20'
                                                }}>
                                                    Login
                                                </Button>
                                            </div>
                                        </> : <>
                                            <Form.Item
                                                label="Email / Phone"
                                                name="email"

                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please Enter your Email/Phone!",
                                                    },
                                                ]}
                                            >
                                                <Input disabled={otpKey != null} placeholder="Enter your email/phone" />
                                            </Form.Item>

                                            {otpKey ?

                                                <>
                                                    <Alert message="An OTP has been sent to your email address. Please check your inbox or spam folder." type="success" className="mb-3" />
                                                    <Form.Item
                                                        label="OTP"
                                                        name="otp"
                                                        rules={[
                                                            { required: true, message: "Please Enter otp!" },
                                                        ]}
                                                    >
                                                        <Input.Password placeholder="Enter OTP" />
                                                    </Form.Item>
                                                </>
                                                : null}

                                            <div className="flex text-end w-full justify-between">
                                                {otpKey ?
                                                    <div className="mt-2 pl-2 cursor-pointer" onClick={() => setOtpKey()}>Reset</div> : <div></div>
                                                }

                                                <Button type="primary" htmlType="submit" className="mt-2 __btn px-4 __bt_primary border-0" style={{
                                                    backgroundColor: '#E72D20'
                                                }}>
                                                    {otpKey ? 'Login' : 'Get OTP'}
                                                </Button>
                                            </div>
                                        </>

                                        }
                                    </Form>


                                    {/* <Button
                                    type="primary"
                                    className="mt-5 __btn px-4 __bt_primary border-0"
                                    style={{
                                        // backgroundColor: '#E72D20'
                                    }}
                                    onClick={() => {
                                        setLoginType(loginType == 20 ? 10 : 20)
                                    }}
                                >
                                    {loginType == 20 ? 'Delegate Login' : 'Exhibitor Login'}
                                </Button> */}


                                </div>
                                <div className={`${templateType == 10 ? 'mt-5 w-full' : 'mt-1 w-full'}`}>
                                    <Row gutter={[8, 8]} className="w-full flex justify-center items-center ">
                                        {props.android_url || process.env.NEXT_PUBLIC_PLAY_STORE ?
                                            <Col span={8} sm={7} md={4} lg={6} xxl={5} className="p-2">
                                                <a href={props.android_url || process.env.NEXT_PUBLIC_PLAY_STORE}>
                                                    <img width={'100%'} src={'/images/playstore.png'} />
                                                </a>
                                            </Col> : null
                                        }
                                        {props.android_url || process.env.NEXT_PUBLIC_PLAY_STORE ?
                                            <Col span={8} sm={7} md={4} lg={6} xxl={5} className="p-2">
                                                <a href={props.ios_url || process.env.NEXT_PUBLIC_APP_STORE} >
                                                    <img width={'100%'} src={'/images/appstore.png'} />
                                                </a>
                                            </Col>
                                            : null}
                                    </Row>
                                </div>
                            </div>
                            {props.login_note ?
                                <div className="loginNote" dangerouslySetInnerHTML={{ __html: props.login_note }}>
                                </div> : null}

                        </div>
                    </div>
                </div>
            </div >

            <div className="__arrow cursor-pointer" ref={arrowRef} onClick={scrollToBtm}>
                <ArrowDownOutlined />
            </div>
        </Layout >
    </>
};





Login.getLayout = function getLayout(page) {
    return page
}

const CarouselItem = ({ adsCount, index, carousel }) => {

    const [items, setItems] = useState(carousel)
    useEffect(() => {
        if (carousel.length > 1) {
            if (index == 1) {
                let data = [...carousel.length == 1 ? carousel.concat(carousel) : carousel]
                let i = data.shift()
                let ii = data.concat(i)
                setItems(ii)
            } else if (index == 2) {
                let data = [...carousel.length == 1 ? carousel.concat(carousel) : carousel]
                let i = data.shift()
                let ii = data.concat(i)
                i = ii.shift()
                ii = ii.concat(i)
                setItems(ii)
            }
        }

    }, [index, adsCount, carousel])


    return <Carousel
        key={index + adsCount}
        autoplay={true}
        dots={false}
        style={{ width: 300, height: 200, alignItems: 'center' }}
    >
        {
            (items || []).map(x => {
                return <a href={x.banner_url || '#'} key={x.exhibitor_banner_id} className="w-full0">
                    <img
                        className="rounded shadow-7xl flex-10 bg-white w-full"
                        alt=""
                        src={`${x.banner_image}`} />
                </a>
            })
        }
        {/* {
            (carousel || []).map(x => {
                return <a href={x.banner_url || '#'} key={x.exhibitor_banner_id} className="w-full0">
                    <img
                        className="rounded shadow-7xl flex-10 bg-white w-full h-full"
                        alt=""
                        src={`${x.banner_image}`}
                    />
                </a>
            })
        } */}
    </Carousel>
}



export const getServerSideProps = async (context) => {
    const id = context.params.id

    const q = context.query
    
    let configs = {};
    try{
     configs = await getConfig({refreshCookie: true, req: context.req, res: context.res});
    }catch(e){
        console.error(e);
    }

    const host = getSubdomainFromHost(context.req.headers.host);
    const clientConfig = configs[host] || {};
    // context.res.setHeader(
    //     "Set-Cookie",
    //     `nevendo_client_config=${encodeURIComponent(
    //         JSON.stringify({ [host]: clientConfig })
    //     )}; Path=/;`
    // );

    var v = {}
    if (q) {
        Object.keys(q).map(x => {
            v[x] = q[x]
        })
    }

    const { res: data, ...d } = await getExhibitorLoginScreen(id, q, context.req)
        .then(x => {
            if (x.event_logo) {
                const exp = ` expires=${(new Date(Date.now() + 86400 * 1000)).toUTCString()}; path=/;`;
                context?.res?.setHeader(
                    'Set-Cookie',
                    [
                        `event_logo=${x.event_logo};${exp}`,
                        `nevendo_client_config=${encodeURIComponent(
                            JSON.stringify({ [host]: clientConfig })
                        )}; Path=/`,
                    ]
                );
            }
            // return { props: x }
            return ({ res: x })
        })
        .catch(e => {
            const res = e?.response?.status || 522;
            return {
                error: `couldn't find the thing`,
                errorCode: res,
                errorTitle: e?.response ? res.message || 'This Event is not Found or closed for Login' : (e?.name == 'CustomError' ? e.message : 'Something went wrong! Please try again')
            }
        })

    if (d.errorCode) {
        if (d.errorCode == 401) {
            return {
                redirect: {
                    destination: "/logout",
                }
            }
        }
        return {
            props: d
        }
    }


    return { props: { ...data, id } };
}



export default Login;